import { mapState } from 'vuex'
import {
  ECOVENTURE_CATEGORIES
} from '../../../helpers/constants'
import {
  getTripLength
} from '../../../helpers/ecoventureHelpers'

export default {
  computed: {
    ...mapState(['selectedProgrammes']),
    quantity: {
      get () {
        const currentNum = this.selectedProgrammes.filter(pg => {
          return this.pg.id === pg.id
        })

        return currentNum.length
      },
      set (quantity) {
        const currentNum = this.selectedProgrammes.filter(pg => {
          return this.pg.id === pg.id
        }).length

        if (quantity > currentNum) {
          this.$store.commit('addToCart', this.pg)
        }
        else if (quantity < currentNum) {
          this.$store.commit('removeFromCart', this.pg)
        }
      }
    },
    isProgrammeSelected () {
      return this.selectedProgrammes.some(pg => {
        return pg.id === this.pg.id
      })
    },
    pricingBasis () {
      if (this.pg.category === ECOVENTURE_CATEGORIES.EXPEDITION) {
        return '/trip'
      }

      return '/week'
    },
    tripLength () {
      return getTripLength(this.pg)
    },
    tripPrice () {
      if (this.pg.category === ECOVENTURE_CATEGORIES.ECOVENTURE) {
        return this.pg.eco_weekly_price
      }
      else if (this.pg.category === ECOVENTURE_CATEGORIES.EXPEDITION) {
        return this.pg.expedition_price
      }

      return 0
    }
  },
  methods: {
    handleSetActiveProgramme () {
      this.$store.commit('setActiveProgramme', this.pg)
    },
    handleAddProgramme () {
      this.$store.commit('addToCart', this.pg)
    }
  }
}